/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Broker_Col_NameInputs */

const cs_import_broker_col_name = /** @type {(inputs: Import_Broker_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jméno`)
};

const en_import_broker_col_name = /** @type {(inputs: Import_Broker_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Import_Broker_Col_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_broker_col_name = /** @type {((inputs?: Import_Broker_Col_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Broker_Col_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_broker_col_name(inputs)
	return cs_import_broker_col_name(inputs)
});